import { render, staticRenderFns } from "./CallbackPage.vue?vue&type=template&id=b2bbbe72&scoped=true&"
import script from "./CallbackPage.vue?vue&type=script&lang=ts&"
export * from "./CallbackPage.vue?vue&type=script&lang=ts&"
import style0 from "./CallbackPage.vue?vue&type=style&index=0&id=b2bbbe72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bbbe72",
  null
  
)

export default component.exports